import React from "react";
  import API from "../../services/api";


function PopupVideoBlock({ block, updateBlock, removeBlock }) {

const uploadVideo =
async (e) => {

  const file =
    e.target.files[0];

  if (!file) return;

  const formData =
    new FormData();

  formData.append(
    "file",
    file
  );

  try {

    const res =
      await API.post(

        "/upload",

        formData,

        {

          headers: {

            "Content-Type":
            "multipart/form-data"

          }

        }

      );

    updateBlock(

      block.id,

      "url",

      res.data.url

    );

  }

  catch(error) {

    console.log(error);

  }

};

  return (

    <div className="popup-block popup-video-block">

      <h4>🎬 Bloc Vidéo</h4>

<input
  type="file"
  accept="video/*"
  onChange={uploadVideo}
/>

{block.url && (

  <video

    src={block.url}

    controls

    style={{
      width: "100%",
      marginTop: "10px"
    }}

  />

)}

      <select
        value={block.width || "100"}
        onChange={(e) =>
          updateBlock(
            block.id,
            "width",
            e.target.value
          )
        }
      >
        <option value="50">50%</option>
        <option value="75">75%</option>
        <option value="100">100%</option>
      </select>

      <label>

        <input
          type="checkbox"
          checked={block.autoplay || false}
          onChange={(e) =>
            updateBlock(
              block.id,
              "autoplay",
              e.target.checked
            )
          }
        />

        Lecture automatique

      </label>

      <label>

        <input
          type="checkbox"
          checked={block.controls !== false}
          onChange={(e) =>
            updateBlock(
              block.id,
              "controls",
              e.target.checked
            )
          }
        />

        Afficher les contrôles

      </label>

      {block.url && (

        <div className="video-preview">

          <video
            src={block.url}
            controls={block.controls !== false}
            autoPlay={block.autoplay || false}
            style={{
              width: `${block.width || 100}%`,
              marginTop: "10px",
              borderRadius: "8px"
            }}
          />

        </div>

      )}

      <button
        className="remove-block-btn"
        onClick={() =>
          removeBlock(block.id)
        }
      >
        ❌ Supprimer
      </button>

    </div>

  );

}

export default PopupVideoBlock;